import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import RemovableTag from "components/Removables/RemovableTag";
import React from "react";
import { ModalPickerProps } from "../props";
import TagList from "./TagList";

interface Props extends ModalPickerProps<server.dto.TagForList> {
  mainArea: server.dto.MainAreas;
}

const TagModalPicker = (props: Props) => {
  return <>
    <ModalPickerWithChooseButton
      onNewClicked={() => { }}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={RESX.Tag.Tags}
      modalSize="mini"
      renderModalContent={(closeModal) => <TagList
        excludeKeys={props.excludeKeys}
        mainArea={props.mainArea}
        onItemSelected={(tag) => {
          closeModal();
          props.onChange(tag);
        }}
      />}
      renderRemovable={(props) => <RemovableTag {...props} />}

      {...props}
    />
  </>;
};

export default TagModalPicker;